export function addClass(obj, name) {
    if (typeof obj == "undefined") return;
    if (obj.className == "") {
        obj.className = name;
    } else {
        if (hasClass(name, obj.className)) return;
        obj.className += " " + name;
    }
}
export function removeClass(obj, name) {
    if (typeof obj == "undefined" || !hasClass(name, obj.className)) return;
    const classArray = obj.className.split(" ");
    let names = "";
    for (let i = 0; i < classArray.length; i++) {
        if (classArray[i] == name) {
            classArray.splice(i, 1);
        }
    }
    names = classArray.join(" ");
    obj.className = names;
}

export function hasClass(name, names) {
    const re = new RegExp("^" + name + "$|^" + name + "\\s|\\s" + name + "\\s|\\s" + name + "$", "g")
    return re.test(names);
}
// 获取字符字节长度
export function getLen(str) {
    let len = 0
    if (str) {
        str = str.replace(/\s+/g, "") + '' // to string
        for (let i = 0; i < str.length; i++) {
            const c = str.charCodeAt(i)
            if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
                len++ // 单字节
            } else {
                len += 3 // 汉字
            }
        }
    }
    return len
}

/**
 * @param {Number} timeStamp 传入的时间戳
 * @param {String} startType 要返回的时间字符串的格式类型，传入'year'则返回年开头的完整时间
 */
export const getDate = (timeStamp, startType) => {
    const d = new Date(timeStamp)
    const year = d.getFullYear()
    const month = getHandledValue(d.getMonth() + 1)
    const date = getHandledValue(d.getDate())
    const hours = getHandledValue(d.getHours())
    const minutes = getHandledValue(d.getMinutes())
    const second = getHandledValue(d.getSeconds())
    let resStr = ""
    switch (startType) {
        case "all":
            resStr = year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + second
            break
        case "date":
            resStr = year + "-" + month + "-" + date
            break
        case "time":
            resStr = hours + ":" + minutes + ":" + second
            break
        case "year":
            resStr = year
            break
        case "dateNumber":
            resStr = year + "" + month + "" + date;
            break
    }
    return resStr
}

/**
 * @param {Number} num 数值
 * @returns {String} 处理后的字符串
 * @description 如果传入的数值小于10，即位数只有1位，则在前面补充0
 */
const getHandledValue = num => {
    return num < 10 ? '0' + num : num
}
